import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ProgressBar from "./ProgressBar";
import PdfViewerModal from "./Modal/PdfViewer/index";
import "./dateRangePickerAdmin.scss";
import {
  Grid,
  TextField,
  Autocomplete,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../redux/administrator/actions";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "./Snackbars/CustomizedSnackbars";

export default function DashboardTable(props) {
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const getDataToFilter = useSelector((state) => state?.admin?.dataToFilter);
  const [dataToFilter, setDataToFilter] = useState({});
  const searchFilterData = useSelector(
    (state) => state?.admin?.searchFilterData
  );
  const [searchFilter, setSearchFilter] = useState("");
  const [selectedPdf, setSelectedPdf] = useState("");
  const [selectedParameter, setSelectedParameter] = useState("");
  const [outOfRange, setOutOfRange] = useState("");
  const [pdfView, setPdfView] = useState(false);
  const [imageLink, setImageLink] = useState("");
  const [coordinates, setCoordinates] = useState([]);

  useEffect(() => {
    if (searchFilterData?.data !== undefined) {
      setSearchFilter(searchFilterData?.data);
    }
  }, [searchFilterData?.data]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      batchId: localStorage.batch_id,
      selectedPdf: "",
      selectedParameter: "",
      outOfRange: "",
    };
    dispatch(acts?.extractionDetailFilter(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acts?.extractionDetailFilter]);

  useEffect(() => {
    if (getDataToFilter?.data !== undefined) {
      setDataToFilter(getDataToFilter?.data);
    }
    setRowsPerPage(rowsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDataToFilter?.data]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      batchId: localStorage.batch_id,
    };
    dispatch(acts.getDataToFilter(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    // Perform search with the selected values
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      batchId: localStorage.batch_id,
      selectedPdf: selectedPdf,
      selectedParameter: selectedParameter,
      outOfRange: outOfRange,
    };
    dispatch(acts?.getDataToFilter(data));

    // Add your search logic here
  };

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.message !== null && apiStatus?.loader) {
        setLoader(true);
        setMessage(apiStatus?.message);
        setErr(true);
      } else {
        setLoader(false);
      }
    }
  }, [apiStatus]);

  const handlePDFView = (coordinates, page_url) => {
    setCoordinates(coordinates);
    setImageLink(page_url);
    setPdfView(true);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    const data = {
      page: value + 1,
      page_size: rowsPerPage,
      batchId: localStorage.batch_id,
    };
    dispatch(acts.getDataToFilter(data));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  function Row(props) {
    const { list } = props;
    return (
      <React.Fragment>
        <Grid container className="table-data AuditActivity">
          <Grid item sm={3}>
            {list?.parameter_name}
          </Grid>
          <Grid item sm={3}>
            {list?.parameter_value}
          </Grid>
          <Grid item sm={2}>
            {list?.pdf_name}
          </Grid>
          <Grid item sm={2}>
            {list?.out_of_range}
          </Grid>
          <Grid item sm={2}>
            <IconButton
              onClick={(lit) => handlePDFView(list.coordinates, list.page_url)}
            >
              <Typography>{parseInt(list?.page_no)}</Typography>
            </IconButton>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  return (
    <div className="Admin-BatchInfo-wrap">
      <Grid container className="action-wrap" spacing={2} alignItems="center">
        <Grid className="action-select-wrap" item md={3}>
          <Autocomplete
            id="combo-box-demo"
            size="small"
            className="input-drop-select"
            options={searchFilter?.pdf_list?.map((item) => item.pdf_name) || []}
            value={selectedPdf}
            onChange={(event, newValue) => setSelectedPdf(newValue)}
            renderInput={(params) => <TextField {...params} label="Pdf's" />}
          />
        </Grid>
        <Grid className="action-select-wrap" item md={3}>
          <Autocomplete
            size="small"
            id="combo-box-demo"
            className="input-drop-select"
            options={
              searchFilter?.parameter_list?.map(
                (item) => item.parameter_name
              ) || []
            }
            value={selectedParameter}
            onChange={(event, newValue) => setSelectedParameter(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Parameter Name" />
            )}
          />
        </Grid>
        <Grid className="action-select-wrap" item md={2}>
          <Autocomplete
            size="small"
            className="input-drop-select"
            id="combo-box-demo"
            options={["True", "False"]}
            value={outOfRange}
            onChange={(event, newValue) => setOutOfRange(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Out of Range" />
            )}
          />
        </Grid>
        <Grid className="serach-contain" item md={2}>
          <Button
            className="btn-search"
            variant="contained"
            onClick={handleSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>
      <Box className="Audit-table-wrap">
        <Grid container className="tableHeader">
          <Grid item xs={3}>
            Parameter Name
          </Grid>
          <Grid item xs={3}>
            Value
          </Grid>
          <Grid item xs={2}>
            Pdf Name
          </Grid>
          <Grid item xs={2}>
            Out of Range
          </Grid>
          <Grid item xs={2}>
            Page no.
          </Grid>
        </Grid>
        <Grid>
          {dataToFilter?.data &&
            dataToFilter?.data?.length > 0 &&
            dataToFilter?.data?.map((list, i) => (
              <Row
                key={list?.pre_processor_id + i}
                list={list}
                i={i}
                props={props}
              />
            ))}
        </Grid>
      </Box>
      {loader && <ProgressBar />}
      {pdfView && (
        <PdfViewerModal
          isOpenModal={pdfView}
          handleClose={() => setPdfView(false)}
          imageLink={imageLink}
          coordinates={coordinates}
        />
      )}
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
      <Grid
        className="pagination-wrap"
        //  pagination-bg"
      >
        <TablePagination
          component="div"
          rowsPerPageOptions={[100, 200, 300, 500]}
          count={parseInt(dataToFilter?.total_count)}
          page={parseInt(page)}
          onPageChange={handlePageChange}
          rowsPerPage={parseInt(rowsPerPage)}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </div>
  );
}
